/* LIBERHAUS · внутренние страницы 2026 — поведение. Разметка приходит с сервера (секции lh3-*).
   1) ролики .lvid и первого экрана For creators: по видимости 60 %, не больше 2 на десктопе и 1 на телефоне (общий предел);
      Save-Data, «меньше движения» и снимки (webdriver) — только обложки;
   2) кружки цвета в карточках; 3) карточка товара: варианты, галерея, нижняя полоса; 4) фильтр коллекции; 5) подарок сезона. */
(function () {
  if (window.LH3) return;
  var d = document;
  var quiet = navigator.webdriver || (navigator.connection && navigator.connection.saveData) ||
    (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);
  var mobile = window.matchMedia && matchMedia('(max-width:749px)').matches;
  var cap = mobile ? 1 : 2, playing = [];
  function stop(v) { v.pause(); var i = playing.indexOf(v); if (i > -1) playing.splice(i, 1); }
  function play(v) {
    if (playing.indexOf(v) > -1) return;
    while (playing.length >= cap) stop(playing[0]);
    playing.push(v);
    var p = v.play(); if (p && p.catch) p.catch(function () { stop(v); });
  }
  var io = (!quiet && 'IntersectionObserver' in window) ? new IntersectionObserver(function (es) {
    es.forEach(function (en) { if (en.intersectionRatio >= 0.6) play(en.target); else stop(en.target); });
  }, { threshold: [0, 0.6] }) : null;
  // обложки роликов — только когда ролик рядом с экраном (до прокрутки не грузятся)
  var pio = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (en) { if (en.isIntersecting) { var v = en.target; if (v.dataset.poster) { v.poster = v.dataset.poster; v.removeAttribute('data-poster'); } pio.unobserve(v); } });
  }, { rootMargin: '300px 300px' }) : null;
  function wire(root) {
    root.querySelectorAll('.lvid').forEach(function (f) {
      if (f.dataset.w) return; f.dataset.w = '1';
      var v = f.querySelector('video'), b = f.querySelector('.lvid__play');
      if (v && v.dataset.poster) { if (pio) pio.observe(v); else { v.poster = v.dataset.poster; } }
      if (b) b.addEventListener('click', function (e) { e.preventDefault(); if (v.paused) play(v); else stop(v); });
      if (io && v) io.observe(v);
    });
  }
  window.LH3 = { play: play, stop: stop, quiet: quiet, cap: cap, wire: wire };
  // >>> фидбэк 26.10 п.6: кнопка ролика — Pause, пока ролик играет, Play на паузе (значок и aria-label). По событиям видео:
  // автозапуск по видимости, остановка соседним роликом и нажатие — одинаково
  var lvbP = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 4.5v15l12-7.5z" fill="currentColor"/></svg>',
    lvbS = '<svg viewBox="0 0 24 24" aria-hidden="true" style="margin-left:0"><path d="M6.5 4.5h4v15h-4zM13.5 4.5h4v15h-4z" fill="currentColor"/></svg>';
  function lvbSync(v) {
    var b = v.parentElement && v.parentElement.querySelector('.lvid__play'); if (!b) return;
    var on = !v.paused && !v.ended, k = on ? '1' : '0'; if (b.getAttribute('data-on') === k) return;
    b.setAttribute('data-on', k); b.setAttribute('aria-label', on ? 'Pause creator video' : 'Play creator video');
    var s = b.querySelector('span'); if (s) s.innerHTML = on ? lvbS : lvbP;
  }
  ['play', 'playing', 'pause', 'ended', 'emptied'].forEach(function (t) {
    d.addEventListener(t, function (e) { var v = e.target; if (v && v.tagName === 'VIDEO') lvbSync(v); }, true);
  });
  // <<< фидбэк 26.10 п.6
  // картинка не загрузилась с шириной — один повтор без ширины (оригинал CDN)
  window.LH3IE = window.LH3IE || function (i) { if (i.dataset.r) return; i.dataset.r = '1'; var s = i.getAttribute('src') || ''; i.removeAttribute('srcset'); i.src = s.replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, ''); };
  d.addEventListener('error', function (e) { var t = e.target; if (t && t.tagName === 'IMG' && /width=/.test(t.getAttribute('src') || '')) window.LH3IE(t); }, true);

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function w(u, px) { return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + px; }
  var STAR = '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="m12 2.8 2.8 5.9 6.4.8-4.7 4.4 1.2 6.4L12 17.2l-5.7 3.1 1.2-6.4-4.7-4.4 6.4-.8z"/></svg>';
  function stars(s, r) {
    var h = '<span class="stars" role="img" aria-label="' + esc(r) + ' out of 5 stars">';
    for (var i = 1; i <= 5; i++) { var f = s >= i ? 100 : s >= i - 0.5 ? 50 : 0;
      h += '<span style="position:relative;display:inline-block;width:14px;height:14px"><span style="position:absolute;inset:0;opacity:.25">' + STAR + '</span><span style="position:absolute;inset:0;overflow:hidden;width:' + f + '%">' + STAR + '</span></span>'; }
    return h + '</span>';
  }
  function pk(img, cut, alt, px) {
    return '<div class="pk' + (cut === '1' ? ' is-cut' : '') + '"><img src="' + esc(w(img, px || 900)) + '" alt="' + esc(alt) + '" width="900" height="900" decoding="async" onerror="LH3IE(this)"></div>';
  }

  // ── кружки цвета в карточках сетки: фото, ссылка и оценка меняются на месте ──
  d.addEventListener('click', function (e) {
    var b = e.target.closest('[data-card] .sw'); if (!b) return;
    e.preventDefault();
    var c = b.closest('[data-card]');
    c.querySelectorAll('.sw').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
    var p = c.querySelector('.pk'); if (p) p.outerHTML = pk(b.dataset.img, b.dataset.cut, b.getAttribute('aria-label'));
    var bd = c.querySelector('.lh-badge'); if (bd) bd.hidden = b.dataset.a !== c.dataset.bdgA;
    c.querySelectorAll('[data-link]').forEach(function (x) { x.href = b.dataset.href; });
    var r = c.querySelector('[data-rate]');
    if (r) r.innerHTML = b.dataset.r ? '<div class="card__r">' + stars(+b.dataset.s, b.dataset.r) + ' <span>' + esc(b.dataset.r) + ' · ' + esc(b.dataset.n) + '</span></div>' : '';
    var g = d.querySelector('[data-gift]'); // подарок сезона (Holiday)
    if (g && c.contains(g)) { g.href = b.dataset.buy; g.textContent = 'Buy on Amazon · ' + b.dataset.price; }
  });

  // ── карточка товара ──
  function initPdp(root) {
    var data = root.querySelector('[data-lh3-members]'); if (!data) { gallery(root); return; }
    var J = JSON.parse(data.textContent), M = J.m, cur = root.dataset.sku, base = cur;
    var box = root.querySelector('[data-buybox]');
    function inPlace(a) {
      var p = M[a]; if (!p) return; cur = a;
      var sec = root.parentElement || root; // нижняя полоса — рядом с карточкой, не внутри
      var main = root.querySelector('[data-main]'); if (main) main.innerHTML = pk(p.i, p.k, p.n, 1200);
      var t = root.querySelector('.thumbs button'); if (t) t.innerHTML = pk(p.i, p.k, p.n, 200);
      sec.querySelectorAll('[data-name],[data-name-s]').forEach(function (x) { x.textContent = p.n; });
      sec.querySelectorAll('[data-price],[data-price-s]').forEach(function (x) { x.textContent = p.p; });
      var cpel = root.querySelector('[data-cp]'); if (cpel) { cpel.hidden = !p.cp; cpel.textContent = p.cp ? 'List Price: ' + p.cp : ''; }
      var pc = root.querySelector('[data-pcap]'); if (pc) { pc.hidden = p.ps !== 'amazon'; pc.textContent = 'Amazon price, ' + (p.pd || J.today); }
      var rw = root.querySelector('[data-rate-wrap]');
      if (rw) rw.innerHTML = p.r ? '<div class="rate">' + stars(+p.s, p.r) + '<b>' + esc(p.r) + '</b><span class="small">' + esc(p.c) + ' ratings</span><span class="cap">' + esc(p.rc) + '</span></div>' : '';
      if (window.LH3VS) window.LH3VS(root, a);
      var bs = root.querySelector('[data-bsb]'); if (bs) bs.hidden = a !== base;
      sec.querySelectorAll('[data-buy]').forEach(function (x) { x.href = p.b; });
      var bc = root.querySelector('[data-buycap]');
      if (bc) bc.textContent = 'Opens this item on Amazon.com';
      var lk = root.querySelector('[data-lock]'); if (lk) lk.hidden = p.lk !== '1';
      // фото листинга — только своего товара: у цвета вне Shopify их нет
      var own = p.u && a === base;
      root.querySelectorAll('[data-listing]').forEach(function (x) { x.hidden = !own; });
      // критик r2 каталога: у плитки без своей карточки — без описания и ухода страницы; у другой семьи сайта — и без её роликов
      var mine = a === base, fam = !p.f || !M[base] || p.f === M[base].f;
      sec.querySelectorAll('[data-own]').forEach(function (x) { x.hidden = !mine; });
      sec.querySelectorAll('[data-own-note]').forEach(function (x) { x.hidden = mine; });
      sec.querySelectorAll('[data-fam-only]').forEach(function (x) { x.hidden = !fam; });
      root.querySelectorAll('[data-fam-video]').forEach(function (x) { x.hidden = !fam; var sl = stage && stage.children[+x.dataset.go]; if (sl) sl.hidden = !fam; });
      go(0);
      d.title = p.n + ' · LIBERHAUS';
      try { var u = new URL(location.href); if (a === base) u.searchParams.delete('v'); else u.searchParams.set('v', a); history.replaceState(null, '', u); } catch (e) {}
    }
    function swap(a) {
      var p = M[a]; if (!p || a === cur) return;
      if (p.u && a !== base) { // другой товар Shopify: его секция целиком
        inPlace(a);
        var my = (window.LH3.seq = (window.LH3.seq || 0) + 1); // быстрые клики: устаревший ответ не подменяет новый выбор
        fetch(p.u + '?sections=' + encodeURIComponent(root.dataset.section)).then(function (r) { return r.json(); }).then(function (j) {
          if (my !== window.LH3.seq || cur !== a) return;
          var html = j[root.dataset.section]; if (!html) throw 0;
          var doc = new DOMParser().parseFromString(html, 'text/html'), sec = root.parentElement;
          var fresh = doc.querySelector('[data-lh3-pdp]'); if (!fresh) throw 0;
          var y = window.scrollY;
          sec.innerHTML = fresh.outerHTML + [].map.call(doc.querySelectorAll('.sbar-space,[data-sbar]'), function (x) { return x.outerHTML; }).join('');
          window.scrollTo(0, y);
          history.replaceState(null, '', p.u + '?v=' + a);
          var nr = sec.querySelector('[data-lh3-pdp]'); if (window.LH3VS) window.LH3VS(nr, nr.dataset.sku); initPdp(nr); wire(sec);
        }).catch(function () { if (my === window.LH3.seq && cur === a) location.href = p.u; });
        return;
      }
      window.LH3.seq = (window.LH3.seq || 0) + 1;
      inPlace(a);
    }
    box && box.addEventListener('click', function (e) {
      var v = e.target.closest('[data-v]');
      if (v) { e.preventDefault(); swap(v.dataset.v); return; }
    });
    // галерея
    var stage = root.querySelector('[data-stage]'), thumbs = root.querySelectorAll('.thumbs button'), dots = root.querySelectorAll('.dots i');
    function slides() { return [].filter.call(stage.children, function (x) { return !x.hidden; }); }
    function go(i) {
      var s = slides(); if (!s[i]) i = 0;
      [].forEach.call(stage.children, function (x) { x.classList.remove('is-on'); });
      if (s[i]) s[i].classList.add('is-on');
      thumbs.forEach(function (t) { if (+t.dataset.go === [].indexOf.call(stage.children, s[i])) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); });
      if (mobile || matchMedia('(max-width:989px)').matches) stage.scrollTo({ left: s[i] ? s[i].offsetLeft - stage.offsetLeft : 0, behavior: 'smooth' });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { var el = stage.children[+t.dataset.go]; go(slides().indexOf(el)); }); });
    stage && stage.addEventListener('scroll', function () {
      var i = Math.round(stage.scrollLeft / stage.clientWidth), n = slides().length;
      dots.forEach(function (x, j) { x.hidden = j >= n; x.classList.toggle('on', i === j); });
    }, { passive: true });
    // нижняя полоса на телефоне: видна, когда главная кнопка ушла с экрана
    var sb = root.parentElement.querySelector('[data-sbar]'), mb = root.querySelector('#mainbuy');
    if (sb && mb && 'IntersectionObserver' in window) new IntersectionObserver(function (es) { es.forEach(function (e) { sb.classList.toggle('is-hidden', e.isIntersecting); }); }, { threshold: 0 }).observe(mb);
    // >>> фидбэк 26.10 п.1 (27.10): ?color=<цвет> — тот же выбор, что ?v=<ASIN> (ссылка владельца ?color=teal открывала Black).
    // Вариант той же семьи (прочие оси — как у базового товара), цвет — подпись на сайте или ось Color Amazon; «-handle» в конце не в счёт
    function byColor(c) {
      var h = function (s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').replace(/-handle$/, ''); };
      c = h(c); if (!c) return null;
      var ci = (J.dims || []).indexOf('Color'), bd = (M[base] && M[base].d) || [], hit = null;
      Object.keys(M).some(function (a) {
        var dd = M[a].d || [];
        for (var i = 0; i < dd.length; i++) if (i !== ci && dd[i] !== bd[i]) return false;
        if (h(M[a].l) === c || (ci > -1 && h(dd[ci]) === c)) { hit = a; return true; }
        return false;
      });
      return hit;
    }
    // <<< фидбэк 26.10 п.1
    try { var sp = new URLSearchParams(location.search), q = sp.get('v'); if (!q && sp.get('color')) q = byColor(sp.get('color')); if (q && M[q] && q !== cur) inPlace(q); } catch (e) {}
  }
  function gallery(root) { // товар вне ядра: только миниатюры
    var stage = root.querySelector('[data-stage]'); if (!stage) return;
    root.querySelectorAll('.thumbs button').forEach(function (t) { t.addEventListener('click', function () {
      [].forEach.call(stage.children, function (x, j) { x.classList.toggle('is-on', j === +t.dataset.go); });
      root.querySelectorAll('.thumbs button').forEach(function (x) { if (x === t) x.setAttribute('aria-current', 'true'); else x.removeAttribute('aria-current'); });
    }); });
    var dots = root.querySelectorAll('.dots i');
    stage.addEventListener('scroll', function () { var i = Math.round(stage.scrollLeft / stage.clientWidth); dots.forEach(function (x, j) { x.classList.toggle('on', i === j); }); }, { passive: true });
  }

  // ── фильтр коллекции: вид, штуки, цвет ──
  function initFilter(root) {
    var boxes = root.querySelectorAll('[data-f]'); if (!boxes.length) return;
    function apply() {
      var sel = {}; boxes.forEach(function (b) { if (b.checked) (sel[b.dataset.f] = sel[b.dataset.f] || []).push(b.value); });
      var items = root.querySelectorAll('[data-fi]'), shown = 0;
      items.forEach(function (it) {
        var ok = Object.keys(sel).every(function (k) { var have = (it.getAttribute('data-' + k) || '').split(' '); return sel[k].some(function (v) { return have.indexOf(v) > -1; }); });
        it.hidden = !ok; if (ok) shown++;
      });
      root.querySelectorAll('[data-fsec]').forEach(function (s) { s.hidden = !s.querySelector('[data-fi]:not([hidden])'); });
      var em = root.querySelector('[data-fempty]'); if (em) em.hidden = shown > 0;
    }
    boxes.forEach(function (b) { b.addEventListener('change', apply); });
  }

  // ── порядок карточек коллекции: Popular (продажи за 30 дней, с сервера), A-Z, цена ──
  function initSort(sel) {
    var grid = d.querySelector('[data-plp]'); if (!grid) return;
    function run(v) {
      var cards = [].slice.call(grid.children);
      cards.sort(function (a, b) {
        if (v === 'title-ascending') return a.dataset.name.localeCompare(b.dataset.name);
        if (v === 'price-ascending') return a.dataset.price - b.dataset.price || a.dataset.pop - b.dataset.pop;
        if (v === 'price-descending') return b.dataset.price - a.dataset.price || a.dataset.pop - b.dataset.pop;
        return a.dataset.pop - b.dataset.pop;
      });
      cards.forEach(function (c) { grid.appendChild(c); });
      try { var u = new URL(location.href); if (v === 'manual') u.searchParams.delete('sort_by'); else u.searchParams.set('sort_by', v); history.replaceState(null, '', u); } catch (e) {}
    }
    sel.addEventListener('change', function () { run(sel.value); });
    try { var q = new URLSearchParams(location.search).get('sort_by'); if (q && sel.querySelector('option[value="' + q + '"]')) { sel.value = q; run(q); } } catch (e) {}
  }

  function init() {
    d.querySelectorAll('[data-sort]').forEach(initSort);
    wire(d);
    d.querySelectorAll('[data-lh3-pdp]').forEach(initPdp);
    d.querySelectorAll('[data-lh3-filter]').forEach(initFilter);
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
})();
